module.exports = __webpack_public_path__ + "static/media/Galaxy.80a2faba.png";